import gql from 'graphql-tag';
import apollo from 'src/features/apolloSecure';

const query = gql`
query GetSettings($kind: String) {
  settings(kind: $kind) {
    id
    key
    value
    type
    kind
  }
}`;

export function parseSettings(settings) {
  const fields = {};
  settings.forEach((item) => {
    fields[item.key] = {
      ...item,
      value: item.type === 'bool' ? item.value === 'true' : item.value,
    };
  });
  return fields;
}

function getSettings(kind) {
  return apollo.client.query({
    variables: { kind },
    query,
    fetchPolicy: 'network-only',
  }).then((res) => parseSettings(res.data.settings));
}

export default getSettings;
